const { isPhoto, isResume } = require("../../utils/checkFiletype.js");

const openToViewFdbk = (vueObj) => {
  vueObj.clearAndCloseFdbk = false;
  vueObj.$bvModal.show("fillfeedback");
};
const openToFillFdbk = (vueObj) => {
  vueObj.clearAndCloseFdbk = true;
  vueObj.$bvModal.show("fillfeedback");
};
const closemarks = (vueObj, index) => {
  vueObj.marksdetails.assessmentResponse[index].viewdetails =
    !vueObj.marksdetails.assessmentResponse[index].viewdetails;
  vueObj.$forceUpdate();
};
const getDate = (vueObj) => {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  vueObj.getCurrentDate = `${day}/${month}/${year}`;
};
const handleKeyUp = (vueObj) => {
  window.clearTimeout(vueObj.timer);
  vueObj.timer = window.setTimeout(() => {
    let current = vueObj.multiCurrentPage;
    vueObj.multiCurrentPage = 1;
    if (current === vueObj.multiCurrentPage) {
      vueObj.getSendMultipleJob();
    }
  }, 1000);
};
const myMethod = (vueObj, data) => {
  vueObj.ScheduleInterview["panelist"] = {
    email: data.email,
    panelID: data.panelID,
    name: data.name,
    phoneNumber: data.phoneNumber,
    folderID: data.folderID,
    panelUserID: data.userID,
    roleName: data.roleName,
  };

  vueObj.addPanelist();
};
const openFolderModal = (vueObj, flag) => {
  vueObj.$store.commit("folderVUEX/resetExpand");
  vueObj.$store.commit("folderVUEX/setModalType", flag);
  vueObj.$store.commit("folderVUEX/setActiveFolder", {});

  vueObj.showFolderModal = true;
};
// NAVIGATE TO VIEW REQUIRED DOCUMENTS
const viewRequiredDocs = (vueObj, candidateID) => {
  vueObj.$router.push({
    name: "viewRequiredCandidateDocs",
    query: {
      jobID: vueObj.$route.query.jobID,
      jobTitle: vueObj.$route.query.jobTitle,
      customerID: vueObj.$route.query.customerID,
      cardName: vueObj.$route.query.cardName,
      candidateID: candidateID,
    },
  });
};
const sendForOpshead = (vueObj) => {
  vueObj.$v.select_opsHeadName.$touch();
  vueObj.$v.opsHeadRemarks.$touch();
  if (
    !vueObj.$v.opsHeadRemarks.required ||
    !vueObj.$v.select_opsHeadName.required
  ) {
    vueObj.errorModal("Please enter all the details");
  } else {
    vueObj.feedback.sendOpshead = true;
    vueObj.$bvModal.hide("SelOpsheadFinal");
  }
};
// OPEN MODAL FOR DIRECT ON-HOLD OF SELECTED CANDIDATES
const openFinalOnHold = (vueObj, candidate) => {
  vueObj.finalSelectedCandidate = candidate;
  vueObj.$bvModal.show("final-hold");
};
// CLOSE MODAL FOR DIRECT ON-HOLD OF SELECTED CANDIDATES
const closeFinalHold = (vueObj) => {
  vueObj.finalSelectedCandidate = {};
  vueObj.$bvModal.hide("final-hold");
};
// OPEN MODAL FOR POSTING ON-HOLD ACTION FOR SELECTED CANDIDATES
const openFinalAction = (vueObj, candidate) => {
  vueObj.finalSelectedCandidate = candidate;
  vueObj.finalSelectedCandidate.select = null;
  vueObj.$bvModal.show("final-action");
  vueObj.finalAction = true;
};
// CLOSE MODAL FOR POSTING ON-HOLD ACTION FOR SELECTED CANDIDATES
const closeFinalAction = (vueObj) => {
  vueObj.finalSelectedCandidate = {};
  vueObj.$bvModal.hide("final-action");
  vueObj.finalAction = false;
};
// GET USERID OF OPSHEAD SELECTED FOR FINAL APPROVAL VIA KANBAN
const getApproverId = (vueObj) => {
  vueObj.down = !vueObj.down;
  const foundItem = vueObj.opsHeadList.find(
    (item) => item.username === vueObj.select_opsHeadName
  );
  vueObj.approverUserID = foundItem.userID;
};
// REMOVE A SELECTED PANELIST
const removePanelist = (vueObj) => {
  vueObj.clearDetails = true;
  vueObj.ScheduleInterview.panelist = {};
  vueObj.teamsStatus = null;
  vueObj.panelistStatus = null;
};
const closeSelOpshedFinalModal = (vueObj) => {
  vueObj.$bvModal.hide("SelOpsheadFinal");
  vueObj.down = false;
  vueObj.searchQuery = "";
  vueObj.select_opsHeadName = "";
  vueObj.opsHeadRemarks = "";
  vueObj.selectrec = "";
  vueObj.feedback.recommendation = "";
  vueObj.$v.$reset();
};

const closeNotinterestedModal = (vueObj) => {
  vueObj.$bvModal.hide("notInterested");
  vueObj.$v.$reset();
  vueObj.notInterestedRemarks = "";
};
const closefillFeedbackmodal = (vueObj) => {
  vueObj.$bvModal.hide("fillfeedback");
  if (vueObj.clearAndCloseFdbk) {
    vueObj.clearFeedbckDetails();
  }
};

const selectrejectedround = (vueObj, i) => {
  vueObj.rejectedroundselected = i;
};
const rejectConfirmModal = (vueObj, data) => {
  vueObj.rejectschedulemodal = true;
  vueObj.confirmmodal = false;
  vueObj.rejectsendassessment = false;
  vueObj.rejectscheduleinterview = false;
  vueObj.activeCandidate = data;
  for (let i in vueObj.activeCandidate["customerID"]) {
    if (
      vueObj.activeCandidate["customerID"][i][vueObj.$route.query.jobID] !=
      undefined
    ) {
      if (
        vueObj.activeCandidate["customerID"][i][vueObj.$route.query.jobID]
          .level == "NI"
      ) {
        vueObj.activeCandidate.roundstatuslevel =
          vueObj.activeCandidate["customerID"][i][
            vueObj.$route.query.jobID
          ].notInterestedInLevel;
        vueObj.activeCandidate.roundstatusname = "Not Interested";
      } else if (
        vueObj.activeCandidate["customerID"][i][vueObj.$route.query.jobID]
          .level == "H"
      ) {
        vueObj.activeCandidate.roundstatuslevel =
          vueObj.activeCandidate["customerID"][i][
            vueObj.$route.query.jobID
          ].onHoldInLevel;
        vueObj.activeCandidate.roundstatusname = "On Hold";
      } else if (
        vueObj.activeCandidate["customerID"][i][vueObj.$route.query.jobID]
          .level == "R"
      ) {
        vueObj.activeCandidate.roundstatuslevel =
          vueObj.activeCandidate["customerID"][i][
            vueObj.$route.query.jobID
          ].rejectInLevel;
        vueObj.activeCandidate.roundstatusname = "Rejected";
      }
    }
  }

  vueObj.selectedAssessment = {};
  vueObj.rejectedroundselected = {};
  vueObj.$bvModal.show("schedrejectedmodal");
};

const clearFeedbackForm = (vueObj, objModal) => {
  vueObj.feedback = {
    interviewID: "",
    name: "",
    panelName: "",
    experience: "",
    modeOfInterview: "",
    evalDate: "",
    recommendation: "",
    candidateImage: "",
    feedbackForm: "",
    recruiterRemarks: "",
    processedBy: "",
  };
  objModal.fileCheck = false;
  objModal.fileCheckImage = false;
  objModal.activeTab = "giveFeedback";

  objModal.checkMedia1 = false;
  objModal.checkimage = false;
  objModal.resumefailed = false;
  vueObj.feedback.feedbackForm = "";
  vueObj.selectrec = null;
  removeImage(vueObj, objModal);
  removefeedback(vueObj, objModal);
  vueObj.$v.feedback.$reset();
  objModal.feedbackerror = false;
  objModal.isFailed = false;
  objModal.$bvModal.hide("feedback");
};
const closeConfigView = (vueObj) => {
  vueObj.$bvModal.hide("modal-1");
};
const removefeedback = (vueObj, objModal) => {
  vueObj.fileInputKey++;
  vueObj.resumeFiles = [];
  vueObj.feedback.feedbackForm = "";
  objModal.checkMedia1 = false;
  objModal.fileCheck = false;
  objModal.fileCheckImage = false;

  objModal.resumefailed = false;
};
const removeImage = (vueObj, objModal) => {
  vueObj.image = [];
  vueObj.feedback.candidateImage = "";
  objModal.checkimage = false;
  objModal.isFailed = false;
};
const clearFeedbckDetails = (vueObj) => {
  for (const i of vueObj.feedbackform.skills) {
    i.comments = "";
    i.mark = "";
  }
};
const scheduleInterviewModal = (vueObj, Details) => {
  vueObj.scheduleModal = true;
  vueObj.ScheduleInterview.toolTipTitle = "Copy";
  vueObj.ScheduleInterview.schedulename = "Schedule Interview";
  vueObj.ScheduleInterview.scheduleButton = "Schedule";
  const emailDomain = vueObj.roleValues.email.split("@")[1];
  if (emailDomain == "simplify3x.com") {
    vueObj.ScheduleInterview.selectedOption = "Microsoft Teams";
    vueObj.ScheduleInterview.withTeams = true;
    vueObj.ScheduleInterview.withVccl = true;
  } else {
    vueObj.ScheduleInterview.selectedOption = " None";
    vueObj.ScheduleInterview.withTeams = false;
    vueObj.ScheduleInterview.withVccl = false;
  }

  vueObj.activeCandidate = Details;
  vueObj.ScheduleInterview.roundlevel = vueObj.activeCandidate.kanbanLevel;
  vueObj.ScheduleInterview.jobID = vueObj.$route.query.jobID;
  vueObj.ScheduleInterview.customerID = vueObj.$route.query.customerID;
  vueObj.ScheduleInterview.panelist = {};
  vueObj.teamsToken = "";
  vueObj.$bvModal.show("scheduleModal");
};

const previewImage = (vueObj, event, objModal) => {
  let input = event.target;
  if (input?.files?.[0]) {
    let reader = new FileReader();
    objModal.image = input.files[0];

    reader.readAsDataURL(input.files[0]);
    let parts = input.files[0].name.split(".");
    objModal.screenshotname = input.files[0].name;
    let fileSizeInBytes = input.files[0].size;

    let fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    if (fileSizeInMB < 5) {
      objModal.fileCheckImage = true;
    } else {
      objModal.fileCheckImage = false;
    }
    let ext = parts[parts.length - 1];
    vueObj.feedback.candidateImage = ext;
    if (!isPhoto(vueObj.feedback.candidateImage)) {
      objModal.isFailed = true;
      vueObj.Candidate.isFailed = true;
      objModal.checkimage = false;
      // IF the File Type is invalid then delete "QUESTION MEDIA" / "MEDIA TYPE" from the PAYLOAD
      objModal.image = "";
      delete vueObj.feedback.candidateImage;
    } else {
      // FOR getting the extension of a particular file
      objModal.checkimage = true;
      objModal.isFailed = false;
      objModal.imageError = false;
      objModal.image = input.files[0];
      // FOR Checking if the fileType is valid or NOT
      reader.onload = (e) => {
        vueObj.feedback.candidateImage = e.target.result;
        vueObj.$forceUpdate();
      };
    }
  }
  event.target.value = "";
};

const previewFeedback = (vueObj, event, objModal) => {
  let input = event.target;
  if (input?.files?.[0]) {
    let reader = new FileReader();

    vueObj.resumeFiles = input.files[0];
    objModal.feedbackfilename = input.files[0].name;
    let fileSizeInBytes = input.files[0].size;

    // Convert the size to megabytes
    let fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    if (fileSizeInMB < 5) {
      objModal.fileCheck = true;
    } else {
      objModal.fileCheck = false;
    }

    reader.readAsDataURL(input.files[0]);
    // FOR getting the extension of a particular file
    let parts = input.files[0].name.split(".");
    let ext = parts[parts.length - 1];
    vueObj.feedback.feedbackForm = ext;
    // FOR Checking if the fileType is valid or NOT
    if (!isResume(vueObj.feedback.feedbackForm)) {
      objModal.checkMedia1 = false;
      // IF the File Type is invalid then delete "QUESTION MEDIA" / "MEDIA TYPE" from the PAYLOAD
      vueObj.resumeFiles = "";
      vueObj.resumefailed = true;
      delete vueObj.feedback.feedbackForm;
    } else {
      // FOR storing the FILE OBJECT Copy of the uploaded FILE
      objModal.checkMedia1 = true;
      objModal.resumefailed = false;
      vueObj.resumeFiles = input.files[0];
      objModal.feedbackerror = false;

      reader.onload = (e) => {
        // FOR storing the binary value of a FILE
        vueObj.feedback.feedbackForm = e.target.result;
      };
    }
  }
  event.target.value = "";
};

const copyToClipboard = (vueObj) => {
  try {
    const meetingLink = vueObj.ScheduleInterview.meetingLink;
    if (meetingLink !== "") {
      navigator.clipboard.writeText(meetingLink);
      vueObj.ScheduleInterview.toolTipTitle = "Copied";
    }
  } catch (error) {
    console.error("Error copying to clipboard:", error);
  }
};
const changeToolTipTitle = (vueObj) => {
  vueObj.ScheduleInterview.toolTipTitle = "Copy";
};

const endtime = (vueObj) => {
  let year = String(vueObj.ScheduleInterview.date).slice(0, 4);

  let month = String(vueObj.ScheduleInterview.date).slice(5, 7);

  let day = String(vueObj.ScheduleInterview.date).slice(8, 10);

  let hrs = String(vueObj.ScheduleInterview.startTime).slice(0, 2);

  let min = String(vueObj.ScheduleInterview.startTime).slice(3, 5);

  const d = new Date(year, month, day, hrs, min, 0, 0);

  d.setMinutes(d.getMinutes() + 45);

  let endtime = d.toTimeString().slice(0, 5);
  vueObj.ScheduleInterview.endTime = endtime;
};
module.exports = {
  endtime,
  changeToolTipTitle,
  copyToClipboard,
  openToViewFdbk,
  openToFillFdbk,
  closemarks,
  getDate,
  handleKeyUp,
  myMethod,
  openFolderModal,
  viewRequiredDocs,
  openFinalOnHold,
  closeFinalHold,
  openFinalAction,
  closeFinalAction,
  getApproverId,
  removePanelist,
  closeSelOpshedFinalModal,
  closeNotinterestedModal,
  closefillFeedbackmodal,
  selectrejectedround,
  rejectConfirmModal,
  clearFeedbackForm,
  closeConfigView,
  removefeedback,
  removeImage,
  clearFeedbckDetails,
  scheduleInterviewModal,
  previewImage,
  sendForOpshead,
  previewFeedback,
};
